import { LANGUAGE } from '@/types/commonConst';

import type { MessageMap } from '..';

export const workflowMessages = {
  WORKFLOW_DESCRIPTION: {
    [LANGUAGE.EN]:
      'Set up a regular updates by sharing dashboards in a PDF format to designated slack channel(s).',
  },
} as const satisfies MessageMap;
